import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  width: 300px;
  padding-bottom: 20px;
`;
